import React, { Component } from 'react';
import { Icon, Button } from 'react-materialize';

export default class ChartEditorNavBar extends Component {
    render(){
        return <div className="chart-editor-navbar">
            <Button className="ce-navbar-btn ce-float-right" flat onClick={this.props.onSave}>Save<Icon left>save</Icon></Button>
            <Button className="ce-navbar-btn ce-float-left ce-navbar-close-btn" flat onClick={this.props.onClose}><Icon>close</Icon></Button>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/chart-editor/ChartEditorNavBar.jsx